/**
 * RoyalSlider gallery
 * @param container {jQuery}
 */
export function royalSlider(container) {
    /**
     * Valószínű, hogy ezt még pontosítani kell, de másik jegy keretében
     */
    const fullScreenSlider = container.find('.fullscreenSlider');
    if (fullScreenSlider.length === 0) {
        throw {element: fullScreenSlider, reason: 'not found'};
    }
    fullScreenSlider.show().royalSlider({
        updateSliderSize: true,
        fullscreen: {
            enabled: false,
            nativeFS: true
        },
        controlNavigation: 'thumbnails',
        autoScaleSlider: true,
        loop: false,
        imageScaleMode: 'fit-if-smaller',
        navigateByClick: true,
        numImagesToPreload: 3,
        arrowsNav: true,
        arrowsNavAutoHide: true,
        arrowsNavHideOnTouch: true,
        keyboardNavEnabled: true,
        fadeinLoadedSlide: true,
        globalCaption: true,
        globalCaptionInside: true,
        thumbs: {
            appendSpan: true,
            firstMargin: true,
            paddingBottom: 4,
            autoCenter: true
        }
    });
    Plugin = fullScreenSlider.data('royalSlider');
    Plugin.ev.on('rsAfterContentSet', () => {
        if ($('#gallery-close').length == 0) {
            fullScreenSlider.find('.rsOverflow').append('<div id="gallery-close" class="rsFullscreenBtn rsCloseVideoIcn"></div>');
            $('#gallery-close').on('click.dealPage', () => {
                fullScreenSlider.fadeOut('slow');
            });
        }
    });
}
